import initVueApp from "@/core.js";
const component = require(`./../views/Blog.vue`).default;
initVueApp(component);
